module.exports = __webpack_public_path__ + "static/media/reports.4080f11c.png";